var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"disabled":this.dataStore3.currentPage === this.dataStore3.catAmount ? true : false,"color":"primary"},on:{"click":function($event){_vm.increment(); _vm.$vuetify.goTo(0);}}},[_vm._v(" Next ")])}
var staticRenderFns = []

export { render, staticRenderFns }